module.exports = "/images/Create your submittal log - 7.jpg";